// extracted by mini-css-extract-plugin
export default {"previewMeta":"SentEmailsTable_previewMeta__jicdO","previewMetaLabel":"SentEmailsTable_previewMetaLabel__dBPqm","previewBody":"SentEmailsTable_previewBody__Qb3MY"};